import { z } from 'zod';
import { toZonedTime } from 'date-fns-tz';
import { getISODay } from 'date-fns';
import { DayOfWeekSchema, type DayOfWeek } from './dayOfWeek';

export const HHMMSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);

export const JanelaNegociosSchema = z.object({
  janelaId: z.string().uuid(),
  deviceId: z.string().min(1),
  tenantId: z.string().min(1),
  diasSemana: z.array(DayOfWeekSchema).min(1),
  horaInicio: HHMMSchema,
  horaFim: HHMMSchema,
  timezone: z.string().min(1),
  permitirAntecipacao: z.boolean(),
  limiteDiario: z.number().int().min(0),
  updatedBy: z.string().min(1),
  updatedAt: z.string().datetime(),
  effectiveFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});

export type JanelaNegocios = z.infer<typeof JanelaNegociosSchema>;

export function isWithinJanela(janela: JanelaNegocios, now: Date): boolean {
  const localNow = toZonedTime(now, janela.timezone);
  const currentDay = getISODay(localNow) as DayOfWeek;

  if (!janela.diasSemana.includes(currentDay)) return false;
  if (!janela.permitirAntecipacao) return false;

  const [startH = 0, startM = 0] = janela.horaInicio.split(':').map(Number);
  const [endH = 0, endM = 0] = janela.horaFim.split(':').map(Number);
  const startMin = startH * 60 + startM;
  const endMin = endH * 60 + endM;
  const nowMin = localNow.getHours() * 60 + localNow.getMinutes();

  // Support windows that cross midnight (e.g. 22:00–02:00)
  if (endMin < startMin) {
    return nowMin >= startMin || nowMin <= endMin;
  }
  return nowMin >= startMin && nowMin <= endMin;
}
